import { makeKTBlock } from './functions.js';
import { BASE_URL } from './variables.js';

const fetchStudentData = function (el) {
  const $curEl = $(el);

  $('#modalDetailActivity').modal('show');

  $('#modalDetailActivity [name="editCalendarID"]').val($curEl.attr('data-id'));

  KTApp.block('#modalDetailActivity', {
    opacity: 0.1,
    state: 'primary',
    message: 'Fetching Data...',
  });

  $.post(BASE_URL + 'Activities/getActivityDetails', {
    type: 'STUDENT',
    id: $curEl.attr('data-id'),
  })
    .done((resp) => {
      if (resp.code != 200) {
        KTApp.unblock('#modalDetailActivity');

        Swal.fire({
          html: 'Unknown Error has Occured! Please try again',
          icon: 'error',
          confirmButtonText: 'Close',
          showCancelButton: false,
        });

        return;
      }

      /** Insert element dinamis ke body */
      $('#modalDetailActivity .activity-row').remove();
      $('#modalDetailActivity').find('.modal-body').append(resp.page);

      /** Re-init Selectpicker */
      $('#modalDetailActivity .selectpicker').each(function () {
        $(this).selectpicker();
      });

      // Cek dulu ini activity-nya udah beres atau belom
      const curResp = resp.data;

      $('#modalDetailActivity #curCreator').val(curResp.CREATOR_NAME);
      $('#modalDetailActivity #curStudent').val(curResp.STUDENT_NAME);

      if (curResp.STUDENT_NUMBERS != '-' || curResp.STUDENT_NUMBERS != null || curResp.STUDENT_NUMBERS != ' ') {
        const sanitizedNumber = curResp.STUDENT_NUMBERS.replace('+', '').replace('-', '').replace(' ', '').trim();

        $('#modalDetailActivity #studentWhatsappContact').show().attr('href', `https://api.whatsapp.com/send?phone=${sanitizedNumber}`);
      } else {
        $('#modalDetailActivity #studentWhatsappContact').hide().attr('href', '');
      }

      $('#modalDetailActivity #studentMonitoringLink').attr('href', `${BASE_URL}/detail_student?id=${curResp.STUDENT_ID}`);
      $('#modalDetailActivity #curTaskType').val(curResp.TASK_TYPE);
      $('#modalDetailActivity #curStartDate').val(curResp.DATE_FROM);
      $('#modalDetailActivity #curDescription').val(curResp.DESCRIPTION);

      if (curResp.STATUS == 'COMPLETED') {
        $('#modalDetailActivity [name="curStatus"]').attr('disabled', true).prop('checked', true);
      } else {
        $('#modalDetailActivity [name="curStatus"]').attr('disabled', false).prop('checked', false);
      }

      $('#modalDetailActivity [name="curFutureFU"]').prop('checked', false).trigger('change');

      $('#modalDetailActivity [name="curStatus"]').prop('checked', false);

      $('#modalDetailActivity #futureFUCard').hide();
      $('#modalDetailActivity #futureFUSections').hide();

      $('#modalDetailActivity').find('button[type="submit"]').attr('disabled', true);

      KTApp.unblock('#modalDetailActivity');
    })
    .fail((err) => {
      console.log('Error', err);
      KTApp.unblock('#modalDetailActivity');

      Swal.fire({
        html: 'Invalid ID! Please try again',
        icon: 'error',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });
    });
};

const submitActivityForm = async function () {
  makeKTBlock('#modalDetailActivity form');

  return new Promise(function (resolve, reject) {
    const formData = new FormData($('#modalDetailActivity form')[0]);

    $.ajax({
      url: BASE_URL + 'Activities/editActiveTask',
      type: 'POST',
      data: formData,
      dataType: 'json',
      processData: false,
      contentType: false,
      success: function (response) {
        makeKTBlock('#modalDetailActivity form', 'hide');
        resolve(response); // return hasil ke pemanggil
      },
      error: function (jqXHR, textStatus, errorThrown) {
        makeKTBlock('#modalDetailActivity form', 'hide');
        reject({ jqXHR, textStatus, errorThrown });
      },
    });
  });
};

const initStudentModal = function () {
  const $submitBtn = $('#modalDetailActivity').find('button[type="submit"]');

  $submitBtn.attr('disabled', true);
  $submitBtn.show();

  /** Listener */
  $(document).on('change', '#modalDetailActivity [name="futureFUCheckbox"]', function () {
    const curCheckbox = $(this);

    if (curCheckbox.is(':checked')) {
      $('#modalDetailActivity #futureFUCard').show();
    } else {
      $('#modalDetailActivity #futureFUCard').hide();
    }
  });

  $(document).on('change', '#modalDetailActivity [name="curStatus"]', function () {
    const curCheckbox = $(this),
      relatedTask = $(this).attr('data-related') ? $(this).attr('data-related').toUpperCase() : null;

    if (curCheckbox.is(':checked')) {
      if (relatedTask != 'DATABASE') {
        $('#modalDetailActivity #futureFUSections').show();
      }

      $submitBtn.attr('disabled', false);
    } else {
      $submitBtn.attr('disabled', true);
      $('#modalDetailActivity #futureFUSections').hide();
    }
  });

  $('#modalDetailActivity').on('shown.bs.modal', function () {
    $('#buttonsave').attr('disabled', true);
    $('#buttonsave').show();
    $('#buttonsave').parent('.modal-footer').show();
  });
};

export { fetchStudentData, initStudentModal, submitActivityForm };
